import {Component, Inject} from '@angular/core';
import {CustomTitleComponent} from '@app/shared/components/custom-title/custom-title.component';
import {MaterialModule} from '@app/material.module';
import {CustomMessageService} from '@app/shared/components/custom-message/custom-message.service';
import {CustomSnackBarService} from '@app/shared/components/custom-snack-bar/custom-snack-bar.service';
import {FormsModule} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
    selector: 'app-observations',
    imports: [CustomTitleComponent, MaterialModule, FormsModule],
    templateUrl: './observations-dialog.component.html',
    styleUrl: './observations-dialog.component.scss',
})
export class ObservationsDialogComponent {
    uiData: any[] = [];
    selected = 0;

    ogData: any;
    facturas: any[] = [];
    status: any;

    observation = '';

    constructor(
        private customMessage: CustomMessageService,
        private customSnackBar: CustomSnackBarService,
        public dialogRef: MatDialogRef<ObservationsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.ogData = data;
        console.log('[constructor] ogData', this.ogData);
        this.facturas = this.ogData.facturas;
        this.status = this.ogData.status;
    }

    async ngOnInit() {}

    _save() {
        this.dialogRef.close({
            observation: this.observation || 'Sin observaciones.',
        });
    }

    _close() {
        this.dialogRef.close();
    }
}
